import moment from 'moment';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import { loadData, saveData } from '../utils/local-storage';
import reducers from './reducers';
import rootSaga from './saga';


/** Create saga middleware */
const sagaMiddleware = createSagaMiddleware();

/** Create store*/
const STORE_KEY = 'redux-state';
const persistedState = loadData(STORE_KEY);
window.console.log(persistedState);
const store = createStore(
    combineReducers({
        ...reducers,
    }),
    persistedState,
    composeWithDevTools(applyMiddleware(sagaMiddleware, thunk)),
);

store.subscribe(() => {
    saveData(STORE_KEY, {
        locale: store.getState().locale,
    });

    moment.locale(store.getState().locale);
});

/** Run saga middleware */
sagaMiddleware.run(rootSaga);

export default store;

export {
    moment,
};
